export default __webpack_public_path__ + "media/images/images/icons/progressbar-f46267590fad1e4ebf3a3378d505bfeb.gif";